import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export interface FaqAccordionItem {
  question: string;
  answer: string;
}

interface FaqAccordionProps {
  title: string;
  description?: string;
  items: FaqAccordionItem[];
}

/**
 * Reusable public FAQ section with the same look as PublicFaqSection, but
 * driven by caller-supplied items. Used by the landing pages that need their
 * own audience-specific questions.
 */
const FaqAccordion = ({ title, description, items }: FaqAccordionProps) => {
  return (
    <section className="py-16 md:py-24 bg-muted/30">
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground">{title}</h2>
          {description ? (
            <p className="mt-4 text-lg text-muted-foreground">{description}</p>
          ) : null}
        </div>

        <Accordion
          type="single"
          collapsible
          className="max-w-3xl mx-auto border rounded-lg bg-background px-4"
        >
          {items.map((item, index) => (
            <AccordionItem key={item.question} value={`faq-${index}`}>
              <AccordionTrigger className="text-left text-base font-semibold">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground leading-relaxed">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FaqAccordion;
